var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-table-cell-products data-table-cell-group group"},_vm._l((_vm.products),function(product){return _c('img',{key:`product_${product.title}`,staticClass:"data-table-cell-products__image",attrs:{"alt":product.title,"title":product.title,"src":product.image}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }